module.exports = __webpack_public_path__ + "static/media/success_icon.b6df854c.png";